<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Regras de acesso e Período de vendas</h1>
        <paragrafo>
          <negrito>Regras de acesso</negrito> e
          <negrito>Período de vendas</negrito> dependem exclusivamente da forma
          de uso do produto determinada pela loja.</paragrafo
        >
        <imagem :src="image_5" />
        <paragrafo>
          <ul>
            <li>
              Selecionar tipo de imagem, após isso clicar no campo “Clique aqui
              para importar a imagem”. Feito isso, selecione:
              <negrito>“FAZER UPLOAD”</negrito>
            </li>
          </ul>
        </paragrafo>
        <paragrafo
          >Abaixo a forma que as imagens aparecerão no site de
          vendas:</paragrafo
        >
        <imagem :src="image_6" />
        <paragrafo
          >A opção marcada em verde corresponde à possibilidade de criar
          campanhas de venda, ou seja, selecionar datas e valores especiais,
          descontos, etc. Neste local serão criados os lotes e a configuração de
          vendas para produtos com variações, ou seja, produtos que possuam
          tipos como: texto, data e horário.</paragrafo
        ><paragrafo
          ><negrito>Por exemplo</negrito>: Poderá haver um produto que esteja
          disponível apenas em uma única data e único valor. Outros terão várias
          datas e valores (Inteira R$20,00 (31/12/2023), Meia R$10,00
          (31/12/2023), Estudante R$5,00 (31/12/2023), etc).</paragrafo
        >
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "RegrasPeriodos",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_5: "/documentacao/produtos/produtos5.png",
      image_6: "/documentacao/produtos/produtos6.png",
    };
  },
};
</script>
